import React from 'react';

import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';

interface DetailsItemProps {
    detailsTitle?: string;
    detailsText?: React.ReactNode;
    detailsButton?: string;
    detailsButtonClick?: () => void;
    isAlert?: boolean;
    additionalInfo?: string;
    dataTestId?: string;
}

export const DetailsItem: React.FC<DetailsItemProps> = (props) => {
    return (
        <>
            <Text variant="div" color={props.isAlert ? 'error' : 'secondary'} size="secondary" indent="4px">
                {props.detailsTitle}
            </Text>
            <Text variant="div" indent={props.detailsButton ? '8px' : undefined}>
                {props.detailsText}
            </Text>
            {props.detailsButton && (
                <Row flex>
                    <Text dataTestId={props.dataTestId} variant="button" color="primary" size="secondary" onClick={props.detailsButtonClick}>
                        {props.detailsButton}
                    </Text>
                </Row>
            )}
            {props.additionalInfo && (
                <Text size="secondary" color="secondary">
                    {props.additionalInfo}
                </Text>
            )}
        </>
    );
};
